import { useState } from "react";
import { SectionHeader } from "../shared/SectionHeader";
import { DangerRow } from "../shared/DangerRow";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function DangerZone() {
  const [deleteDataOpen, setDeleteDataOpen] = useState(false);
  const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [confirmDeleteData, setConfirmDeleteData] = useState("");
  const [confirmDeleteAccount, setConfirmDeleteAccount] = useState("");

  const handleCloseDeleteData = () => {
    setDeleteDataOpen(false);
    setConfirmDeleteData("");
  };
  const handleCloseDeleteAccount = () => {
    setDeleteAccountOpen(false);
    setConfirmDeleteAccount("");
  };

  return (
    <>
      <SectionHeader
        title="Danger Zone"
        description="These actions are irreversible. Proceed with caution."
      />
      <div className="space-y-0">
        <DangerRow
          title="Delete All Data"
          description="Permanently delete all sales records, expenses, and inventory history. Your account and products list will remain."
          buttonLabel="Delete All Data"
          onAction={() => setDeleteDataOpen(true)}
        />
        <DangerRow
          title="Delete Business Account"
          description="Permanently delete your entire account including all data, team members, and subscription. This cannot be undone."
          buttonLabel="Delete Account"
          onAction={() => setDeleteAccountOpen(true)}
        />
        <DangerRow
          title="Transfer Ownership"
          description="Transfer the admin role to another team member. You will lose admin access immediately."
          buttonLabel="Transfer Ownership"
          onAction={() => setTransferOpen(true)}
        />
      </div>

      <Dialog open={deleteDataOpen} onOpenChange={(open) => { setDeleteDataOpen(open); if (!open) setConfirmDeleteData(""); }}>
        <DialogContent className="bg-card border-border">
          <DialogHeader>
            <DialogTitle className="text-destructive">Delete All Data</DialogTitle>
          </DialogHeader>
          <p className="text-[12px] text-muted-foreground">Type the following to confirm:</p>
          <pre className="bg-muted p-3 rounded text-[12px] font-mono text-foreground">DELETE MY DATA</pre>
          <Input
            className="bg-background border-border"
            value={confirmDeleteData}
            onChange={(e) => setConfirmDeleteData(e.target.value)}
            placeholder="Type phrase here"
          />
          <p className="text-[11px] text-muted-foreground">To proceed with deletion, contact support@reviewboost24.com.</p>
          <DialogFooter>
            <Button variant="outline" onClick={handleCloseDeleteData}>Cancel</Button>
            <Button variant="destructive" disabled={confirmDeleteData !== "DELETE MY DATA"} onClick={handleCloseDeleteData}>
              Confirm
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={deleteAccountOpen} onOpenChange={(open) => { setDeleteAccountOpen(open); if (!open) setConfirmDeleteAccount(""); }}>
        <DialogContent className="bg-card border-border">
          <DialogHeader>
            <DialogTitle className="text-destructive">Delete Account</DialogTitle>
          </DialogHeader>
          <p className="text-[12px] text-muted-foreground">Type your business name in UPPERCASE to confirm.</p>
          <Input
            className="bg-background border-border"
            value={confirmDeleteAccount}
            onChange={(e) => setConfirmDeleteAccount(e.target.value)}
            placeholder="e.g. ANGELIC STORE"
          />
          <p className="text-[11px] text-muted-foreground">To proceed with account deletion, contact support@reviewboost24.com.</p>
          <DialogFooter>
            <Button variant="outline" onClick={handleCloseDeleteAccount}>Cancel</Button>
            <Button variant="destructive" disabled={!confirmDeleteAccount} onClick={handleCloseDeleteAccount}>
              Confirm
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={transferOpen} onOpenChange={setTransferOpen}>
        <DialogContent className="bg-card border-border">
          <DialogHeader>
            <DialogTitle className="text-destructive">Transfer Ownership</DialogTitle>
          </DialogHeader>
          <p className="text-[12px] text-muted-foreground">Transfer the admin role to another team member from the Team page. You will lose admin access immediately. To proceed, contact support@reviewboost24.com.</p>
          <DialogFooter>
            <Button variant="outline" onClick={() => setTransferOpen(false)}>Cancel</Button>
            <Button variant="destructive" onClick={() => setTransferOpen(false)}>I understand</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
